import { useState } from 'react'

import Header from './header'
import SignupBar from './signup_bar'

function Layout({ children }: any) {
  const [admin] = useState(null)

  return (
    <div className="flex h-screen w-screen flex-row bg-gray-100 text-gray-600">
      {/* Header container */}
      <div className="h-full w-12 shrink-0 sm:w-56 md:w-80">
        {/* <Header admin={admin} /> */}
      </div>
      <div className="fixed top-0 flex h-full w-12 flex-row  sm:w-56 md:w-80">
        <Header admin={admin} />
      </div>

      <div className="flex w-full flex-col">
        <div className="h-full w-full bg-gray-100">
          <div className="bg-gray-100 py-6 sm:px-16">
            <SignupBar />
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Layout
